import React from 'react'
import { getWholesalerList } from 'app-support/wholesale/state/actions'
import SupportListWrapper from 'core/page/SupportListWrapper'
import N from 'utils-support/navigation'
import { GETSupportedWholesalerRow } from '@cbgms/api'

const onAdd = (): void => {
  N.push('/wholesale/new')
}
const onEdit = (data: GETSupportedWholesalerRow) => {
  N.push(`/wholesale/edit/${data.SupportedWholesaler.UUID}`)
}

const WholesalerList: React.FC<{}> = () => (
  <SupportListWrapper
    translationKey='supported-wholesaler'
    scope='supported-wholesalers'
    loadAction={getWholesalerList}
    onAdd={onAdd}
    onEdit={onEdit}
  />
)

export default WholesalerList
